export { default } from "./ScoutingReportsListContainer";
